import TobaccoAndAlcoholSR from 'libs/shared/ui/src/lib/components/my-evolution/tobaccoAndAlcohol/tobaccoAndAlcohol'

export const TobaccoAlcohol = () => {
  return (
    <div className="mt-10 w-full">
      <TobaccoAndAlcoholSR />
    </div>
  )
}
